// extracted by mini-css-extract-plugin
module.exports = {"Paper":"PrescriptionOverrideList_Paper__1VPu-"};